import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2Icon } from 'lucide-react';
export const RoleRouter: React.FC = () => {
  const {
    role,
    user
  } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      if (role === 'supplier') {
        navigate('/supplier/dashboard');
      } else if (role === 'internal') {
        navigate('/internal/dashboard');
      } else {
        navigate('/login');
      }
    }, 1500);
    return () => clearTimeout(timer);
  }, [role, navigate]);
  return <div className="min-h-screen bg-surface-secondary flex flex-col items-center justify-center" data-id="element-284">
      <Loader2Icon className="w-10 h-10 text-fpg-navy animate-spin mb-4" data-id="element-285" />
      <h2 className="text-xl font-semibold text-text-primary" data-id="element-286">
        Welcome back, {user?.name?.split(' ')[0]}
      </h2>
      <p className="text-text-secondary mt-2" data-id="element-287">Loading your workspace...</p>
    </div>;
};